import {
  ADMIN_CURRENCY_LIST_SUCCESS,
  ADMIN_CURRENCY_LIST_FAILED,
  RESET_ADMIN_CURRENCY_LIST,
  LOADING_ADMIN_CURRENCY_LIST,
  NETWORK_ERROR_ADMIN_CURRENCY_LIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAdminCurrencyList = () => {
  return { type: RESET_ADMIN_CURRENCY_LIST };
};

const getDefaultCurrencyList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_ADMIN_CURRENCY_LIST });
  await partnerServices
    .post("getDefaultCurrencyList", userData, { headers: { AuthToken: authTokenIs } })

    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(defaultCurrencyListsuccess(res.data));
          // history.push({ pathname: "/index/homepage" });
          break;
        default:
          dispatch(defaultCurrencyListfailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_ADMIN_CURRENCY_LIST, payload: err });
    });
};

function defaultCurrencyListsuccess(data) {
  return {
    type: ADMIN_CURRENCY_LIST_SUCCESS,
    payload: data,
  };
}

function defaultCurrencyListfailed(data) {
  return {
    type: ADMIN_CURRENCY_LIST_FAILED,
    payload: data,
  };
}

export { resetAdminCurrencyList, getDefaultCurrencyList };
